import {PromotionType} from "./PromotionType";

export const promotionUrlConstants = {
    types: {
        "oferty-promocyjne": PromotionType.PROMOTION,
        "dni-otwarte": PromotionType.OPEN_DAYS,
        przeceny: PromotionType.DISCOUNT,
        "last-minute": PromotionType.LAST_MINUTE,
        przedsprzedaz: PromotionType.PRESALE,
        "targi-mieszkaniowe": PromotionType.EXHIBITION
    } as Record<string, PromotionType>
};

export const knownPromotionQueryTypes = ["type", "region"];
import {PromotionType} from "./PromotionType";

export const promotionUrlConstants = {
    types: {
        "oferty-promocyjne": PromotionType.PROMOTION,
        "dni-otwarte": PromotionType.OPEN_DAYS,
        przeceny: PromotionType.DISCOUNT,
        "last-minute": PromotionType.LAST_MINUTE,
        przedsprzedaz: PromotionType.PRESALE,
        "targi-mieszkaniowe": PromotionType.EXHIBITION
    } as Record<string, PromotionType>
};

export const knownPromotionQueryTypes = ["type", "region"];
